import * as Sebrae from '@sebrae/react-core';
import * as React from 'react';

import { useInterviewController } from '../../../hooks/controllers/interview-controller';
import { useColorsConfig } from './useColorsConfig';

export function useInterview() {
  const { findInterviewByUserAuth, findInterviewByAdministratorAuth } =
    useInterviewController();
  const { hasRoles } = Sebrae.useAuth();
  const { getColorsByModule } = useColorsConfig();

  const [interview, setInterview] = React.useState(null);
  const [loading, setLoading] = React.useState(false);
  const [error, setError] = React.useState(null);
  const [moduleColors, setModuleColors] = React.useState(null);

  const loadInterview = React.useCallback(
    async (adminId = null) => {
      setLoading(true);
      setError(null);

      try {
        const data =
          hasRoles(['ADMINISTRADOR']) && adminId
            ? await findInterviewByAdministratorAuth(adminId)
            : await findInterviewByUserAuth();

        setInterview(data);

        if (data?.module?.id) {
          const colors = getColorsByModule(data.module.id);
          setModuleColors(colors);
        }

        return data;
      } catch (err) {
        setError(err);
        console.error('Erro ao carregar entrevista:', err);
        throw err;
      } finally {
        setLoading(false);
      }
    },
    [
      findInterviewByUserAuth,
      findInterviewByAdministratorAuth,
      hasRoles,
      getColorsByModule,
    ],
  );

  const clearInterview = React.useCallback(() => {
    setInterview(null);
    setModuleColors(null);
    setError(null);
  }, []);

  return {
    interview,
    moduleColors,
    loading,
    error,
    loadInterview,
    clearInterview,
  };
}
